import React, {Fragment} from 'react'
import classnames from 'classnames'
import get from 'lodash/get'

import FieldLogo from '@fielded/shared-ui/src/components/FieldLogo'

import withConfig from '../../../../van-shared/hoc/withConfig'
import { formatDate } from '../../../../van-shared/utils/utils'
import { isShelflifeCoreApp } from '../../common/utils'

const NoteHeading = ({
  shipment,
  config
}) => {
  const isDistribution = shipment.statusType === 'distribution'
  const label = isDistribution ? 'Package' : 'Delivery'
  const isShelflifeCore = isShelflifeCoreApp(config)

  // For tenants with a dark logo: their main logo may be invisible on package notes (white background).
  // To fix this, we use their dark logo instead when generating package notes.
  const logoUrlDark = get(config, 'logoUrlDark')
  const logoUrl = logoUrlDark || config.logoUrl

  const date = isDistribution
    ? formatDate(get(shipment, 'snapshotDates.sent', shipment.date), 'printLong')
    : formatDate(get(shipment, 'snapshotDates.received', shipment.date), 'printLong')

  return (
    <div className={classnames(
      'note-heading',
      {'note-heading--distribution': isDistribution}
    )}>
      {isShelflifeCore ? (
        <Fragment>
          <div className='note-heading__logo--field'>
            <FieldLogo className='print-template__logo print-template__logo--field' fill='currentColor' />
          </div>
          <span className='note-heading__entity-text'>
            Field Intelligence Development Partners (Shelf Life)
          </span>
        </Fragment>
      ) : (
        <div className='note-heading__logo'>
          <img src={logoUrl} alt={`${config.name} Logo`} className='print-template__logo' />
        </div>
      )}
      <div className='note-heading__info'>
        {label} | {shipment.shipmentNo}
      </div>
      {shipment && shipment.patientName && <div className='note-heading__info'>
        Patient name: {shipment.patientName}
      </div>}
      {shipment && shipment.patientId && <div className='note-heading__info'>
        Patient ID: {shipment.patientId}
      </div>}
      <div className='note-heading__date'>
        {date}
      </div>
      {isShelflifeCore && (
        <div className='note-heading__sender'>
          www.shelflife.co
        </div>
      )}
    </div>
  )
}

export default withConfig(NoteHeading)
